import { useShallow } from "zustand/react/shallow";
import { useTimeline } from "../../../../contexts/TimelineProvider/TimelineProvider";
import { useAudioEffectStore } from "./store";
import { useAudioManagerStore } from "../../../../contexts/PageAudioManager";
import { ReactComponent as LoadingSpinner } from "../../../../assets/icons/Common/loading.svg";
import classes from "../../../../utils/HTML/classes";
import { BAR_HEIGHT } from "../../TimelinePanel";
import { AudioWave } from "../AudioWave";
import { DEFAULT_WAVE_COLOR, SELECTED_WAVE_COLOR } from "../SecondaryAudioWaveBar";

interface AudioEffectWaveBarProps {
  objectId: string;
  selected: boolean;
  onSelect: (selected: boolean) => void;
}

export const AudioEffectWaveBar = ({ objectId, selected, onSelect }: AudioEffectWaveBarProps) => {
  const [, , { clippedSpaceFromUnitSpace }] = useTimeline();
  const [draggingObjectId] = useAudioEffectStore(useShallow((state) => [state.draggingObjectId]));
  const audio = useAudioManagerStore((state) => state.getEffectAudio(objectId));

  if (!audio) {
    return null;
  }

  const width = clippedSpaceFromUnitSpace(audio.end) - clippedSpaceFromUnitSpace(audio.start);
  const canRender = width && audio.ready;

  return (
    <div
      className={classes("audio-wave-bar", {
        "audio-wave-bar--selected": selected,
        // "audio-wave-bar--dragging": isParentDragging,
      })}
      style={{
        width,
      }}
      onClick={(event) => {
        event.stopPropagation();

        onSelect(selected);
      }}
    >
      {canRender ? (
        <div
          style={{
            width,
            height: BAR_HEIGHT,
          }}
        >
          <AudioWave
            waveColor={selected ? SELECTED_WAVE_COLOR : DEFAULT_WAVE_COLOR}
            key={audio.objectId}
            objectId={audio.objectId}
            height={BAR_HEIGHT}
            width={width}
          />
        </div>
      ) : (
        <div className="audio-wave-loading" style={{ width }}>
          <LoadingSpinner className="audio-loading-spinner" />
          <span className="audio-wave-loading-message">Loading Audio...</span>
        </div>
      )}
    </div>
  );
};
